import FilterGroup from '@/pages/category/components/FilterGroup';

interface FilterBarProps {
  genres: string[];
  regions: string[];
  years: number[];
  selectedGenres: string[];
  selectedRegions: string[];
  selectedYears: string[];
  sort: 'updated' | 'hot';
  onToggleGenre: (value: string) => void;
  onToggleRegion: (value: string) => void;
  onToggleYear: (value: string) => void;
  onSortChange: (value: 'updated' | 'hot') => void;
  onReset: () => void;
  activeCount: number;
}

export default function FilterBar({
  genres,
  regions,
  years,
  selectedGenres,
  selectedRegions,
  selectedYears,
  sort,
  onToggleGenre,
  onToggleRegion,
  onToggleYear,
  onSortChange,
  onReset,
  activeCount,
}: FilterBarProps) {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-2">
        <div className="flex items-center gap-2">
          <i className="ri-filter-3-line text-primary-500"></i>
          <span className="text-sm font-semibold text-foreground-900">筛选条件</span>
          {activeCount > 0 && (
            <span className="px-2 py-0.5 rounded-full text-xs bg-accent-100 text-accent-900 whitespace-nowrap">
              已选 {activeCount} 项
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-center bg-background-100 rounded-full p-1">
            <button
              type="button"
              onClick={() => onSortChange('updated')}
              className={`px-3 py-1.5 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                sort === 'updated' ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              按更新日期
            </button>
            <button
              type="button"
              onClick={() => onSortChange('hot')}
              className={`px-3 py-1.5 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                sort === 'hot' ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              按热门程度
            </button>
          </div>
          <button
            type="button"
            onClick={onReset}
            className="px-3 py-2 rounded-md text-sm text-foreground-700 border border-background-300 hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-refresh-line mr-1"></i>
            重置
          </button>
        </div>
      </div>

      <div>
        <FilterGroup label="类型" options={genres} selected={selectedGenres} onToggle={onToggleGenre} />
        <FilterGroup label="地区" options={regions} selected={selectedRegions} onToggle={onToggleRegion} />
        <FilterGroup label="年份" options={years} selected={selectedYears} onToggle={onToggleYear} />
      </div>
    </div>
  );
}